module.exports = __webpack_public_path__ + "img/mb_product_bg.adbd4aa.webp";